// extracted by mini-css-extract-plugin
export default {"wrapper":"Link_wrapper__7If-e","isDisabled":"Link_isDisabled__Px+np"};